import React from "react";
import { Button } from "react-bootstrap";
import type { PaginationMetadata } from "../../types/boards";

interface PaginationControlsProps {
  pagination: PaginationMetadata;
  onPageChange: (page: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  pagination,
  onPageChange
}) => {
  return (
    <div className="d-flex justify-content-center mt-4">
      <Button
        variant="outline-secondary"
        disabled={pagination.currentPage === 1}
        onClick={() => onPageChange(1)}
        className="me-2"
        style={{
          backgroundColor: "#1a182b",
          color: "#FFFFFF",
          borderColor: "rgb(146, 127, 191)"
        }}
      >
        First
      </Button>
      <Button
        variant="outline-secondary"
        disabled={!pagination.hasPreviousPage}
        onClick={() => onPageChange(pagination.currentPage - 1)}
        className="me-2"
        style={{
          backgroundColor: "#1a182b",
          color: "#FFFFFF",
          borderColor: "rgb(146, 127, 191)"
        }}
      >
        Previous
      </Button>
      <span className="align-self-center mx-3" style={{ color: "#BFBFBF" }}>
        Page {pagination.currentPage} of {pagination.totalPages}
      </span>
      <Button
        variant="outline-secondary"
        disabled={!pagination.hasNextPage}
        onClick={() => onPageChange(pagination.currentPage + 1)}
        className="ms-2"
        style={{
          backgroundColor: "#1a182b",
          color: "#FFFFFF",
          borderColor: "rgb(146, 127, 191)"
        }}
      >
        Next
      </Button>
      <Button
        variant="outline-secondary"
        disabled={pagination.currentPage === pagination.totalPages}
        onClick={() => onPageChange(pagination.totalPages)}
        className="ms-2"
        style={{
          backgroundColor: "#1a182b",
          color: "#FFFFFF",
          borderColor: "rgb(146, 127, 191)"
        }}
      >
        Last
      </Button>
    </div>
  );
};

export default PaginationControls;
